import { render } from "./BorderedTeamByProject.vue?vue&type=template&id=45aa1818&ts=true"
import script from "./BorderedTeamByProject.vue?vue&type=script&lang=ts"
export * from "./BorderedTeamByProject.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__